import * as React from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IconStory, IconVideo } from "../../../../utils/icons";
import { isInternal } from "../../../../utils";
import { useUser } from "../../../../hooks/useUser";

interface Props {
  isStories?: boolean;
  onVideoClick?: () => void;
  onStoryClick?: () => void;
}

export default function Switcher({
  isStories,
  onVideoClick,
  onStoryClick,
}: Props) {
  const navigate = useNavigate();
  const { role } = useUser();

  const getProps = (explicitClasses: string, condition?: boolean) => {
    const commonClasses =
      "border py-3 px-4 flex gap-2 cursor-pointer border-muted";
    // Active wash stays literal: bg-opacity-* cannot tint a var()-backed
    // color, so bg-accent would drop the 30% translucency.
    const bgFillClasses = "bg-primary bg-opacity-30";

    return {
      className: `${commonClasses} ${explicitClasses} ${
        condition ? bgFillClasses : ""
      }`,
    };
  };

  return (
    <div className="flex">
      <div
        {...getProps(
          `${isInternal(role) ? "rounded-[4px]" : "rounded-l-xl"}`,
          !isStories
        )}
        onClick={() => (onVideoClick ? onVideoClick() : navigate("/videos"))}
      >
        <IconVideo stroke={isStories ? "#B0B0B0" : "#AB854A"} />
        <Typography
          sx={{ color: !isStories ? "var(--accent-text)" : "var(--text-2)" }}
          fontWeight="bold"
        >
          Videos
        </Typography>
      </div>

      {!isInternal(role) && (
        <div
          {...getProps("rounded-r-xl", isStories)}
          onClick={() =>
            onStoryClick ? onStoryClick() : navigate("/videos/embeds")
          }
        >
          <IconStory stroke={!isStories ? "#B0B0B0" : "#AB854A"} />
          <Typography
            sx={{ color: isStories ? "var(--accent-text)" : "var(--text-2)" }}
            fontWeight="bold"
          >
            Stories
          </Typography>
        </div>
      )}
    </div>
  );
}
